import { FC } from 'react';

import AvatarPlaceHolder from 'assets/images/no-avatar.svg';
import getPractitionerName from 'utils/getPractitionerName';
import { Specialty } from 'interfaces/specialty';
import getPractitionerSpecialists from 'utils/getPractitionerSpecialists';

import AssignedSelectSection from '../AssignedSelectSection/AssignedSelectSection';
import { Operatory } from 'interfaces/operatory';

interface AssignedDoctorSectionProps {
  control: any;
  doctors: {
    id: string;
    avatar: string;
    firstName: string;
    name: string;
    title: string;
    specialist: string;
    specialties: Specialty[];
    operatories: Operatory[];
  }[];
}

const AssignedDoctorSection: FC<AssignedDoctorSectionProps> = ({
  control,
  doctors,
}) => {
  return (
    <AssignedSelectSection
      control={control}
      name="doctorIds"
      title="Doctors Assigned to Split Scheduling"
      tooltipId="doctor-split-scheduling"
      tooltipText="Assigning practitioners to specific recare services."
      placeholder="Select Doctors"
      items={doctors}
      renderItemLabel={(doctor) => (
        <>
          <img
            src={doctor.avatar || AvatarPlaceHolder}
            alt="no-avatar"
            className="rounded-full object-cover w-4.8 h-4.8 aspect-square"
            width={48}
            height={48}
          />
          <div className="flex flex-col">
            <span className="truncate font-bold">
              {getPractitionerName(doctor)}
            </span>
            <span className="w-[30rem] truncate">
              {getPractitionerSpecialists(doctor)}
            </span>
          </div>
        </>
      )}
    />
  );
};

export default AssignedDoctorSection;
